import { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';

import {
  arquivarMpfNotificacao,
  getMpfMinhaFila,
  getMpfNotificacoes,
  marcarMpfNotificacao,
  marcarTodasMpfNotificacoes,
} from 'volto-ministerio-publico-federal/actions';
import type {
  FiltroNotificacoes,
  Notificacao,
} from 'volto-ministerio-publico-federal/helpers/Notificacoes';
import type { NotificacoesState } from 'volto-ministerio-publico-federal/reducers/notificacoes';
import { initialState } from 'volto-ministerio-publico-federal/reducers/notificacoes';

/** Estado e ações da central, compartilhados pelo painel e pela página. */
export const useNotificacoes = () => {
  const dispatch: any = useDispatch();
  const estado: NotificacoesState = useSelector(
    (state: any) => state.mpfNotificacoes ?? initialState,
    shallowEqual,
  );

  const carregar = useCallback(
    (filtro: FiltroNotificacoes, bStart = 0, bSize = 20) =>
      dispatch(getMpfNotificacoes(filtro, bStart, bSize)).catch(() => {}),
    [dispatch],
  );

  const carregarFila = useCallback(
    () => dispatch(getMpfMinhaFila()).catch(() => {}),
    [dispatch],
  );

  const marcarLida = useCallback(
    (item: Notificacao, lida = true) =>
      item.lida === lida
        ? Promise.resolve()
        : dispatch(marcarMpfNotificacao(item.id, lida)).catch(() => {}),
    [dispatch],
  );

  const marcarTodas = useCallback(
    () => dispatch(marcarTodasMpfNotificacoes()).catch(() => {}),
    [dispatch],
  );

  const arquivar = useCallback(
    (item: Notificacao) =>
      dispatch(arquivarMpfNotificacao(item.id)).catch(() => {}),
    [dispatch],
  );

  return { estado, carregar, carregarFila, marcarLida, marcarTodas, arquivar };
};
